// extracted by mini-css-extract-plugin
module.exports = {"icon-label":"OrderMerchant_icon-label__4ms0e"};